<template>
    <div class="container-fluid">
        <div v-if="isLoading" class="row d-flex justify-content-center mt-5">
            <div v-if="this.mostrar == 'Aprobado'" class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div v-else-if="this.mostrar == 'Otorgado'" class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div v-else class="spinner-border text-black" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-else-if="hasError" class="row mt-3">
            <div class="col-12">
                <div class="alert alert-danger text-center mb-0" role="alert">
                    Ocurrió un error al cargar las solicitudes. Intenta nuevamente.
                </div>
            </div>
        </div>

        <div v-else-if="!solicitudes.length" class="row mt-3">
            <div class="col-12">
                <div class="alert alert-secondary text-center mb-0" role="alert">
                    No se encontraron solicitudes para el filtro seleccionado.
                </div>
            </div>
        </div>

        <div v-else class="row text-center mt-3 horizontal-scrollable">
            <table class="table table-striped table-hover" id="myTable">
                <thead>
                    <tr>
                        <th class="text-center">ID</th>
                        <th class="text-center">Solicitante</th>
                        <th class="text-center">Dni</th>
                        <th class="">Monto</th>
                        <th>Sucursal</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody id="tablaMostrar">
                    <tr v-for="(solicitud, index) in this.solicitudes" :key="solicitud.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ solicitud?.clienteNombres }}</td>
                        <td>{{ solicitud?.clienteDni }}</td>
                        <td>{{ this.formatoNumero(solicitud?.monto) }} {{ this.moneda }}</td>
                        <td>{{ solicitud.sucursal }}</td>
                        <td v-if="solicitud?.estado === 'Pendiente'" class="text-warning">{{ solicitud?.estado }}</td>
                        <td v-else-if="solicitud?.estado === 'Aprobado'" class="text-success">{{ solicitud?.estado }}</td>
                        <td v-else-if="solicitud?.estado === 'Rechazado'" class="text-danger">{{ solicitud?.estado }}</td>
                        <td v-else-if="solicitud?.estado === 'Otorgado'" style="color: #248AFD;">{{ solicitud?.estado }}</td>
                        <td v-else class="text-dark">{{ solicitud?.estado }}</td>
                        <td>
                            <a :href="`/solicitud-aceptada/${solicitud.id}`" class="btn btn-am btn-inverse-primary">Ver más</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Security from '@/components/security';
import DataTable from 'datatables.net-dt';
import Swal from 'sweetalert2';
import ExcelJS from "exceljs";

export default {
    data() {
        return {
            data: [],
            solicitudes: [],
            ready: false,
            moneda: 'lps',
            isLoading: true,
            hasError: false,
            dataTableInstance: null,
        }
    },
    props: {
        mostrar: String,
    },
    mounted() {
        this.fetchData()
    },
    beforeUnmount() {
        this.destroyDataTable();
    },
    methods: {
        initializeDataTable() {
            const myTable = document.querySelector("#myTable");
            if (myTable && !this.dataTableInstance) {
                this.dataTableInstance = new DataTable(myTable);
            }
        },
        destroyDataTable() {
            if (this.dataTableInstance && typeof this.dataTableInstance.destroy === 'function') {
                this.dataTableInstance.destroy();
                this.dataTableInstance = null;
            }
        },
        fetchData() {
            this.isLoading = true;
            this.hasError = false;
            this.destroyDataTable();

            const payload = {
                filtroEstado: this.mostrar
            }

            fetch(process.env.VUE_APP_API_URL + "/admin/solicitudes/finanzas", Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.hasError = true;
                        Swal.fire({
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        return;
                    }

                    this.solicitudes = response?.data?.solicitudes || [];
                    this.ready = true;

                    this.$nextTick(() => {
                        if (this.solicitudes.length) {
                            this.initializeDataTable();
                        }
                    });
                })
                .catch(error => {
                    this.hasError = true;
                    this.$emit('error', error)
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleImprimir() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Data");
            worksheet.columns = [
                { header: "Nombre Beneficiario", key: "clienteNombres", width: 30 },
                { header: "ID", key: "clienteId", width: 20 },
                { header: "Monto", key: "monto", width: 10 },
                { header: "Cuenta Bancaria", key: "", width: 20 },
                { header: "Frecuencia Pago", key: "frecuenciaPago", width: 20 },
                { header: "Plazo", key: "plazoPago", width: 10 },
                { header: "Fecha de Caducidad", key: "", width: 20 },
                { header: "Estado", key: "estado", width: 20 },
            ];
            worksheet.getRow(1).font = { bold: true };
            worksheet.addRows(this.solicitudes);
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", "solicitudes.xlsx");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        },
        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US").format(numero)
        },
        dateFormat(param) {
            var fechaISO = param;
            var fecha = new Date(fechaISO);
            var dia = ('0' + fecha.getUTCDate()).slice(-2);
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);
            var anio = fecha.getUTCFullYear();
            var fechaFormateada = dia + '/' + mes + '/' + anio;
            return fechaFormateada;
        },
    }
}
</script>

<style></style>
